import { render } from "./PopUpModal.vue?vue&type=template&id=12516d11&scoped=true"
import script from "./PopUpModal.vue?vue&type=script&lang=js"
export * from "./PopUpModal.vue?vue&type=script&lang=js"

import "./PopUpModal.vue?vue&type=style&index=0&id=12516d11&scoped=true&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12516d11"]])

export default __exports__